import { createSelector } from 'reselect';
import { routesReducerkey } from './constants';

export function appRoutesState(state) {
  return state.get(routesReducerkey);
}

export function getRouteHistory(state) {
  return appRoutesState(state)?.history;
}

export function getLocationState(state) {
  return appRoutesState(state)?.locationState;
}

export function getRouteParams(state) {
  return appRoutesState(state)?.routeParams;
}

export function getLocationSearch(state) {
  return appRoutesState(state)?.locationSearch;
}

export function getTrackingPathName(state) {
  return appRoutesState(state)?.trackingPathName;
}

export const getCombinedRouteParams = createSelector(
  [getRouteParams, getLocationSearch, getLocationState],
  (routeParams, locationSearch, locationState) => ({ ...routeParams, ...locationSearch, ...locationState })
);
